var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_147033",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_147033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49997 7.81712L4.64163 10.6755C4.53469 10.7824 4.39858 10.8359 4.2333 10.8359C4.06802 10.8359 3.93191 10.7824 3.82497 10.6755C3.71802 10.5685 3.66455 10.4324 3.66455 10.2671C3.66455 10.1018 3.71802 9.96573 3.82497 9.85879L6.6833 7.00046L3.82497 4.14212C3.71802 4.03518 3.66455 3.89907 3.66455 3.73379C3.66455 3.56851 3.71802 3.4324 3.82497 3.32546C3.93191 3.21851 4.06802 3.16504 4.2333 3.16504C4.39858 3.16504 4.53469 3.21851 4.64163 3.32546L7.49997 6.18379L10.3583 3.32546C10.4652 3.21851 10.6014 3.16504 10.7666 3.16504C10.9319 3.16504 11.068 3.21851 11.175 3.32546C11.2819 3.4324 11.3354 3.56851 11.3354 3.73379C11.3354 3.89907 11.2819 4.03518 11.175 4.14212L8.31663 7.00046L11.175 9.85879C11.2819 9.96573 11.3354 10.1018 11.3354 10.2671C11.3354 10.4324 11.2819 10.5685 11.175 10.6755C11.068 10.7824 10.9319 10.8359 10.7666 10.8359C10.6014 10.8359 10.4652 10.7824 10.3583 10.6755L7.49997 7.81712Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchClose);
export default __webpack_public_path__ + "static/media/icon-search-close.9a65f82fee5fabab9ff128ca7610497f.svg";
export { ForwardRef as ReactComponent };